import React from 'react';
import BaseTable from '@material-ui/core/Table';

const Table = (props) => <BaseTable {...props} />;

export default Table;
